/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApprovalRequestApproveResponse,
  ApprovalRequestBulkApprove,
  ApprovalRequestBulkApproveBulkApproveResponse,
  ApprovalRequestCancelResponse,
  ApprovalRequestCreate,
  ApprovalRequestCreateResponse,
  ApprovalRequestIndexResponse,
  ApprovalRequestReject,
  ApprovalRequestRejectResponse,
  ApprovalRequestShowResponse,
  ApprovalRequestUpdate,
  ApprovalRequestUpdateResponse,
  ApprovalRequestUserEligibleUsersResponse,
  LoggedEventAuditEventsResponse,
} from '../models';
import {
    ApprovalRequestApproveResponseFromJSON,
    ApprovalRequestApproveResponseToJSON,
    ApprovalRequestBulkApproveFromJSON,
    ApprovalRequestBulkApproveToJSON,
    ApprovalRequestBulkApproveBulkApproveResponseFromJSON,
    ApprovalRequestBulkApproveBulkApproveResponseToJSON,
    ApprovalRequestCancelResponseFromJSON,
    ApprovalRequestCancelResponseToJSON,
    ApprovalRequestCreateFromJSON,
    ApprovalRequestCreateToJSON,
    ApprovalRequestCreateResponseFromJSON,
    ApprovalRequestCreateResponseToJSON,
    ApprovalRequestIndexResponseFromJSON,
    ApprovalRequestIndexResponseToJSON,
    ApprovalRequestRejectFromJSON,
    ApprovalRequestRejectToJSON,
    ApprovalRequestRejectResponseFromJSON,
    ApprovalRequestRejectResponseToJSON,
    ApprovalRequestShowResponseFromJSON,
    ApprovalRequestShowResponseToJSON,
    ApprovalRequestUpdateFromJSON,
    ApprovalRequestUpdateToJSON,
    ApprovalRequestUpdateResponseFromJSON,
    ApprovalRequestUpdateResponseToJSON,
    ApprovalRequestUserEligibleUsersResponseFromJSON,
    ApprovalRequestUserEligibleUsersResponseToJSON,
    LoggedEventAuditEventsResponseFromJSON,
    LoggedEventAuditEventsResponseToJSON,
} from '../models';

export interface CompanySpacesApprovalRequestsBulkApprovePostRequest {
    body?: ApprovalRequestBulkApprove;
}

export interface CompanySpacesApprovalRequestsEligibleUsersGetRequest {
    filterFulltext?: string;
    page?: number;
    perPage?: number;
}

export interface CompanySpacesApprovalRequestsGetRequest {
    filterUserIds?: Array<number>;
    filterProviders?: Array<string>;
    filterRequestTypes?: Array<CompanySpacesApprovalRequestsGetFilterRequestTypesEnum>;
    filterStatuses?: Array<CompanySpacesApprovalRequestsGetFilterStatusesEnum>;
    filterFulltext?: string;
    sort?: string;
    page?: number;
    perPage?: number;
}

export interface CompanySpacesApprovalRequestsIdApprovePostRequest {
    id: string;
    body?: object;
}

export interface CompanySpacesApprovalRequestsIdAuditEventsGetRequest {
    id: string;
}

export interface CompanySpacesApprovalRequestsIdDeleteRequest {
    id: string;
}

export interface CompanySpacesApprovalRequestsIdGetRequest {
    id: string;
}

export interface CompanySpacesApprovalRequestsIdPutRequest {
    id: string;
    body?: ApprovalRequestUpdate;
}

export interface CompanySpacesApprovalRequestsIdRejectPostRequest {
    id: string;
    body?: ApprovalRequestReject;
}

export interface CompanySpacesApprovalRequestsPostRequest {
    body?: ApprovalRequestCreate;
}

export interface CompanySpacesUsersUserIdApprovalRequestsGetRequest {
    userId: number;
    filterRequestTypes?: Array<CompanySpacesUsersUserIdApprovalRequestsGetFilterRequestTypesEnum>;
    filterStatuses?: Array<CompanySpacesUsersUserIdApprovalRequestsGetFilterStatusesEnum>;
    filterProviders?: Array<string>;
    filterFulltext?: string;
    sort?: string;
    page?: number;
    perPage?: number;
}

export interface CompanySpacesUsersUserIdApprovalRequestsIdCancelPostRequest {
    userId: number;
    id: string;
    body?: object;
}

/**
 * 
 */
export class ApprovalRequestApi extends runtime.BaseAPI {

    /**
     */
    async companySpacesApprovalRequestsBulkApprovePostRaw(requestParameters: CompanySpacesApprovalRequestsBulkApprovePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApprovalRequestBulkApproveBulkApproveResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/approval_requests/bulk_approve`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApprovalRequestBulkApproveToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApprovalRequestBulkApproveBulkApproveResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesApprovalRequestsBulkApprovePost(requestParameters: CompanySpacesApprovalRequestsBulkApprovePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApprovalRequestBulkApproveBulkApproveResponse> {
        const response = await this.companySpacesApprovalRequestsBulkApprovePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesApprovalRequestsEligibleUsersGetRaw(requestParameters: CompanySpacesApprovalRequestsEligibleUsersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ApprovalRequestUserEligibleUsersResponse>>> {
        const queryParameters: any = {};

        if (requestParameters.filterFulltext !== undefined) {
            queryParameters['filter_fulltext'] = requestParameters.filterFulltext;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.perPage !== undefined) {
            queryParameters['per_page'] = requestParameters.perPage;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/approval_requests/eligible_users`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApprovalRequestUserEligibleUsersResponseFromJSON));
    }

    /**
     */
    async companySpacesApprovalRequestsEligibleUsersGet(requestParameters: CompanySpacesApprovalRequestsEligibleUsersGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ApprovalRequestUserEligibleUsersResponse>> {
        const response = await this.companySpacesApprovalRequestsEligibleUsersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesApprovalRequestsGetRaw(requestParameters: CompanySpacesApprovalRequestsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ApprovalRequestIndexResponse>>> {
        const queryParameters: any = {};

        if (requestParameters.filterUserIds) {
            queryParameters['filter_user_ids'] = requestParameters.filterUserIds.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.filterProviders) {
            queryParameters['filter_providers'] = requestParameters.filterProviders.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.filterRequestTypes) {
            queryParameters['filter_request_types'] = requestParameters.filterRequestTypes.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.filterStatuses) {
            queryParameters['filter_statuses'] = requestParameters.filterStatuses.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.filterFulltext !== undefined) {
            queryParameters['filter_fulltext'] = requestParameters.filterFulltext;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.perPage !== undefined) {
            queryParameters['per_page'] = requestParameters.perPage;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/approval_requests`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApprovalRequestIndexResponseFromJSON));
    }

    /**
     */
    async companySpacesApprovalRequestsGet(requestParameters: CompanySpacesApprovalRequestsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ApprovalRequestIndexResponse>> {
        const response = await this.companySpacesApprovalRequestsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesApprovalRequestsIdApprovePostRaw(requestParameters: CompanySpacesApprovalRequestsIdApprovePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApprovalRequestApproveResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesApprovalRequestsIdApprovePost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/approval_requests/{id}/approve`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApprovalRequestApproveResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesApprovalRequestsIdApprovePost(requestParameters: CompanySpacesApprovalRequestsIdApprovePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApprovalRequestApproveResponse> {
        const response = await this.companySpacesApprovalRequestsIdApprovePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesApprovalRequestsIdAuditEventsGetRaw(requestParameters: CompanySpacesApprovalRequestsIdAuditEventsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LoggedEventAuditEventsResponse>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesApprovalRequestsIdAuditEventsGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/approval_requests/{id}/audit_events`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LoggedEventAuditEventsResponseFromJSON));
    }

    /**
     */
    async companySpacesApprovalRequestsIdAuditEventsGet(requestParameters: CompanySpacesApprovalRequestsIdAuditEventsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LoggedEventAuditEventsResponse>> {
        const response = await this.companySpacesApprovalRequestsIdAuditEventsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesApprovalRequestsIdDeleteRaw(requestParameters: CompanySpacesApprovalRequestsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesApprovalRequestsIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/approval_requests/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async companySpacesApprovalRequestsIdDelete(requestParameters: CompanySpacesApprovalRequestsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.companySpacesApprovalRequestsIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async companySpacesApprovalRequestsIdGetRaw(requestParameters: CompanySpacesApprovalRequestsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApprovalRequestShowResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesApprovalRequestsIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/approval_requests/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApprovalRequestShowResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesApprovalRequestsIdGet(requestParameters: CompanySpacesApprovalRequestsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApprovalRequestShowResponse> {
        const response = await this.companySpacesApprovalRequestsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesApprovalRequestsIdPutRaw(requestParameters: CompanySpacesApprovalRequestsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApprovalRequestUpdateResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesApprovalRequestsIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/approval_requests/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ApprovalRequestUpdateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApprovalRequestUpdateResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesApprovalRequestsIdPut(requestParameters: CompanySpacesApprovalRequestsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApprovalRequestUpdateResponse> {
        const response = await this.companySpacesApprovalRequestsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesApprovalRequestsIdRejectPostRaw(requestParameters: CompanySpacesApprovalRequestsIdRejectPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApprovalRequestRejectResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesApprovalRequestsIdRejectPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/approval_requests/{id}/reject`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApprovalRequestRejectToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApprovalRequestRejectResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesApprovalRequestsIdRejectPost(requestParameters: CompanySpacesApprovalRequestsIdRejectPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApprovalRequestRejectResponse> {
        const response = await this.companySpacesApprovalRequestsIdRejectPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesApprovalRequestsPostRaw(requestParameters: CompanySpacesApprovalRequestsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApprovalRequestCreateResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/approval_requests`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApprovalRequestCreateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApprovalRequestCreateResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesApprovalRequestsPost(requestParameters: CompanySpacesApprovalRequestsPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApprovalRequestCreateResponse> {
        const response = await this.companySpacesApprovalRequestsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesUsersUserIdApprovalRequestsGetRaw(requestParameters: CompanySpacesUsersUserIdApprovalRequestsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ApprovalRequestIndexResponse>>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling companySpacesUsersUserIdApprovalRequestsGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.filterRequestTypes) {
            queryParameters['filter_request_types'] = requestParameters.filterRequestTypes.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.filterStatuses) {
            queryParameters['filter_statuses'] = requestParameters.filterStatuses.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.filterProviders) {
            queryParameters['filter_providers'] = requestParameters.filterProviders.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.filterFulltext !== undefined) {
            queryParameters['filter_fulltext'] = requestParameters.filterFulltext;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.perPage !== undefined) {
            queryParameters['per_page'] = requestParameters.perPage;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/users/{user_id}/approval_requests`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApprovalRequestIndexResponseFromJSON));
    }

    /**
     */
    async companySpacesUsersUserIdApprovalRequestsGet(requestParameters: CompanySpacesUsersUserIdApprovalRequestsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ApprovalRequestIndexResponse>> {
        const response = await this.companySpacesUsersUserIdApprovalRequestsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesUsersUserIdApprovalRequestsIdCancelPostRaw(requestParameters: CompanySpacesUsersUserIdApprovalRequestsIdCancelPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApprovalRequestCancelResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling companySpacesUsersUserIdApprovalRequestsIdCancelPost.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesUsersUserIdApprovalRequestsIdCancelPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/users/{user_id}/approval_requests/{id}/cancel`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApprovalRequestCancelResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesUsersUserIdApprovalRequestsIdCancelPost(requestParameters: CompanySpacesUsersUserIdApprovalRequestsIdCancelPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApprovalRequestCancelResponse> {
        const response = await this.companySpacesUsersUserIdApprovalRequestsIdCancelPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const CompanySpacesApprovalRequestsGetFilterRequestTypesEnum = {
    RequestCourse: 'request_course',
    RequestTopic: 'request_topic',
    CourseCompletion: 'course_completion'
} as const;
export type CompanySpacesApprovalRequestsGetFilterRequestTypesEnum = typeof CompanySpacesApprovalRequestsGetFilterRequestTypesEnum[keyof typeof CompanySpacesApprovalRequestsGetFilterRequestTypesEnum];
/**
 * @export
 */
export const CompanySpacesApprovalRequestsGetFilterStatusesEnum = {
    Draft: 'draft',
    Approved: 'approved',
    Rejected: 'rejected',
    Cancelled: 'cancelled'
} as const;
export type CompanySpacesApprovalRequestsGetFilterStatusesEnum = typeof CompanySpacesApprovalRequestsGetFilterStatusesEnum[keyof typeof CompanySpacesApprovalRequestsGetFilterStatusesEnum];
/**
 * @export
 */
export const CompanySpacesUsersUserIdApprovalRequestsGetFilterRequestTypesEnum = {
    RequestCourse: 'request_course',
    RequestTopic: 'request_topic',
    CourseCompletion: 'course_completion'
} as const;
export type CompanySpacesUsersUserIdApprovalRequestsGetFilterRequestTypesEnum = typeof CompanySpacesUsersUserIdApprovalRequestsGetFilterRequestTypesEnum[keyof typeof CompanySpacesUsersUserIdApprovalRequestsGetFilterRequestTypesEnum];
/**
 * @export
 */
export const CompanySpacesUsersUserIdApprovalRequestsGetFilterStatusesEnum = {
    Draft: 'draft',
    Approved: 'approved',
    Rejected: 'rejected',
    Cancelled: 'cancelled'
} as const;
export type CompanySpacesUsersUserIdApprovalRequestsGetFilterStatusesEnum = typeof CompanySpacesUsersUserIdApprovalRequestsGetFilterStatusesEnum[keyof typeof CompanySpacesUsersUserIdApprovalRequestsGetFilterStatusesEnum];
